import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'

export function AutoNavigate() {
  // Automaticaly navigate to the next route based on the session state any time that they change. This is meant to be
  // used as a top-level "layout" component that wraps other routes.
  const { autoNavigate } = useAutoNavigate()

  useEffect(() => {
    autoNavigate()
  }, [autoNavigate])

  return <Outlet />
}
